export enum OperatorType {
  Mtn,
  Orange,
  Crypto,
  M2U,
  MojoPay,
}
